import React, { useEffect, useRef, useState } from 'react';
import './Main.css';
import '../../Components/AndroidWaitlistModal.css';
import GoogleAnalytics from '../../Components/Helpers/GoogleAnalytics';
import DefineTrafficSource from './../../Components/Helpers/DefineTrafficSource';
import LoadingPage from '../../Components/LoadingPage';
import AndroidWaitlistModal from '../../Components/AndroidWaitlistModal';

export default function Main() {
    useEffect(() => {
        GoogleAnalytics('/main', {});
    }, []);

    const [isPageLoaded, setIsPageLoaded] = useState(false);
    const [fadeClass, setFadeClass] = useState('');
    const [slideNum, setSlideNum] = useState(0);
    const slideNumRef = useRef(0);

    const screensList = [
        'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/iphone-screenshot-1.png',
        'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/iphone-screenshot-2.png',
        'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/iphone-screenshot-3.png',
        'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/iphone-screenshot-4.png',
        'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/iphone-screenshot-5.png'
    ];

    useEffect(() => {
        const isMobile = window.matchMedia('(max-width: 768px)').matches;

        const imageUrls = isMobile
            ? [
                'https://s3.us-east-2.amazonaws.com/arvel.photos/logos/mob_app_user_home_header_3.png',
                'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/download-ios.png',
                'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/download-android.png'
            ]
            : [
                'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/google-pixel-8-frame.png',
                'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/iphone-15-frame-filled.png',
                'https://s3.us-east-2.amazonaws.com/arvel.photos/logos/mob_app_user_home_header_3.png',
                'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/download-ios.png',
                'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/download-android.png',
                'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/iphone-screenshot-1.png'
            ];

        let loadedCount = 0;
        document.body.classList.add('page-is-loading');

        const checkIfAllLoaded = () => {
            loadedCount++;
            if (loadedCount === imageUrls.length) {
                setIsPageLoaded(true);
                document.body.classList.remove('page-is-loading');
            }
        };

        imageUrls.forEach((url) => {
            const img = new Image();
            img.src = url;
            if (img.complete) {
                checkIfAllLoaded();
            } else {
                img.onload = checkIfAllLoaded;
                img.onerror = checkIfAllLoaded;
            }
        });

        return () => document.body.classList.remove('page-is-loading');
    }, []);

    useEffect(() => {
        DefineTrafficSource();
    }, []);

    useEffect(() => {
        const slideInterval = setInterval(() => {
            setFadeClass('');
            setTimeout(() => setFadeClass('visible'), 100);

            slideNumRef.current = (slideNumRef.current + 1) % screensList.length;
            setSlideNum(slideNumRef.current);
        }, 3300);

        return () => clearInterval(slideInterval);
    }, [screensList.length]);

    const handleAnalytics = (type) => {
        const map = {
            IG: 'Footer_IG',
            LN: 'Footer_LN',
            YT: 'Footer_YouTube',
            X: 'Footer_X',
            DI: 'Footer_delete_instagram',
            'delete-IG': 'Footer_download_IG',
            ios: 'Main_download_ios',
            android: 'Main_download_android',
            contact: 'Footer_contact_us',
            privacy: 'Footer_privacy',
            terms: 'Footer_terms',
            story: 'Footer_our_story',
            explore: 'Footer_explore',
        };

        const action = map[type];
        if (action) {
            GoogleAnalytics('', {
                category: "Main_Page",
                action,
            });
        }
    };

    const renderContent = () => {
        if (!isPageLoaded) return <LoadingPage />;
        return (
            <>
                <div className='body-container'>
                    <div className='column-left'>
                        <img
                            src={'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/google-pixel-8-frame.png'}
                            alt="img"
                            loading="lazy"
                            className='android-frame'
                        />
                        <img
                            src={'https://s3.us-east-2.amazonaws.com/arvel.photos/Web/iphone-15-frame-filled.png'}
                            alt="img"
                            loading="lazy"
                            className='iphone-frame-filled'
                        />
                        {screensList.map((screenshot, index) => (
                            <img
                                key={index}
                                src={screenshot}
                                alt="screenshot"
                                loading="lazy"
                                className={`iphone-screenshot ${index === slideNum ? fadeClass : ''}`}
                                style={{ opacity: index === slideNum ? 1 : 0 }}
                            />
                        ))}
                    </div>

                    <div className='column-right'>
                        <img
                            src='https://s3.us-east-2.amazonaws.com/arvel.photos/logos/mob_app_user_home_header_3.png'
                            alt="logo"
                            loading="lazy"
                            className='company-logo-img'
                        />
                        <h3 className='one-liner'>Experience new things.</h3>
                        <p className='get-app-text'>Get the app.</p>
                        <div className='get-app-btns-container'>
                            <a
                                rel="noopener noreferrer"
                                target="_blank"
                                href="https://apps.apple.com/us/app/arvel-app/id6740179961"
                                onClick={() => handleAnalytics('ios')}
                            >
                                <img
                                    src='https://s3.us-east-2.amazonaws.com/arvel.photos/Web/download-ios.png'
                                    alt="Download iOS"
                                    loading="lazy"
                                    className='download-ios-img'
                                />
                            </a>
                            <AndroidWaitlistModal />
                        </div>
                    </div>
                </div>

                <div className='main-footer-container'>
                    <div className='line-one'>
                        <a href="/our-story" className="page-link" onClick={() => handleAnalytics('story')}><p className='footer-text'>About us</p></a>
                        <a href="/privacy" className="page-link" onClick={() => handleAnalytics('privacy')}><p className='footer-text'>Privacy policy</p></a>
                        <a href="/terms" className="page-link" onClick={() => handleAnalytics('terms')}><p className='footer-text'>Terms of use</p></a>
                        <a href="/contact" className="page-link" onClick={() => handleAnalytics('contact')}><p className='footer-text'>Contact us</p></a>
                        <a href="https://arvel.app/memories/worldwide" className="page-link" onClick={() => handleAnalytics('explore')}><p className='footer-text'>Explore the world</p></a>
                        <a href="/delete-instagram" className="page-link" onClick={() => handleAnalytics('delete-IG')}><p className='footer-text'>Delete Instagram</p></a>
                    </div>

                    <div className='line-two'>
                        <div className='socials-container'>
                            <a href="https://www.youtube.com/channel/UCKnunO7RJLlhfJwfxRYDVLQ" className="page-link" target="_blank" rel="noopener noreferrer" onClick={() => handleAnalytics('YT')}><p className='footer-text'>YouTube</p></a>
                            <a href="https://www.linkedin.com/company/arvel" className="page-link" target="_blank" rel="noopener noreferrer" onClick={() => handleAnalytics('LN')}><p className='footer-text'>LinkedIn</p></a>
                            <a href="https://twitter.com/arvel_app" className="page-link" target="_blank" rel="noopener noreferrer" onClick={() => handleAnalytics('X')}><p className='footer-text'>X</p></a>
                            <a href="https://www.instagram.com/arvel.app/" className="page-link" target="_blank" rel="noopener noreferrer" onClick={() => handleAnalytics('IG')}><p className='footer-text'>IG</p></a>
                        </div>
                        <p className='footer-text'>© 2025 Arvel Inc.</p>
                    </div>
                </div>
            </>
        );
    };

    return (
        <div id="main" className="main main-page">
            {renderContent()}
        </div>
    );
}